import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { postSession } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login");
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const user = await postSession(sessionId);
        setUser(user);
        window.history.replaceState(null, "", "/admin");
        navigate("/admin", { state: { user } });
      } catch (e) {
        setError(e?.response?.data?.detail || "Anmeldung fehlgeschlagen.");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-ink text-cream">
      {error ? (
        <div className="text-center px-6">
          <p className="font-serif text-2xl text-gold mb-4">{error}</p>
          <button onClick={() => navigate("/admin/login")} className="underline text-cream/80">Zurück zum Login</button>
        </div>
      ) : (
        <div className="flex items-center gap-3"><Loader2 className="animate-spin" /> Anmeldung läuft…</div>
      )}
    </div>
  );
}
